<template>
  <!-- <v-layout> -->

  <v-list-item @click="() => { if (!showAdd) { $emit('profile') }}" :style="showAdd ? '' : 'cursor: pointer'">
    <v-list-item-avatar>
      <v-img class="grey lighten-1" :src="profile.photoURL || ''" contain></v-img>
    </v-list-item-avatar>
    <v-list-item-content>
      <v-list-item-title>
        <div :class="`font-weight-bold subheading `">{{ profile.name }}</div>

      </v-list-item-title>
      <v-list-item-subtitle>
        <v-layout column fill-height justify-center align-start>
          <v-row class="pl-2">
            <v-rating v-model="profile.rating" small dense half-increments color="primary" background-color="primary" readonly></v-rating>
            <span class=" caption ml-2">
              ({{ profile.rating }})
            </span>
          </v-row>
          <div>
            <v-icon style="font-size: 12px; vertical-align: baseline;" class="mr-1" >fas fa-briefcase</v-icon> <span :class="` caption`">{{ profile.completedJobs }}
              {{ $language.favorites['jobs completed'] }}</span>
          </div>
        </v-layout>
      </v-list-item-subtitle>

    </v-list-item-content>
    <v-list-item-action v-if="showAdd">
      <v-icon v-if="!status.loading && !isInvited"  color="info" @click="invite">
        fas fa-user-plus
      </v-icon>
      <v-progress-circular v-if="status.loading" small indeterminate color="primary"></v-progress-circular>
      <v-icon v-if="!status.loading && isInvited"  color="success">
        fas fa-check
      </v-icon>
    </v-list-item-action>

  </v-list-item>

  <!--
  <v-flex :class="`${ ? 'grey darken-4' : 'elevation-1' }`" :style="`min-height: 86px; max-height: 86px; ${ ? '' : 'border: 1px solid #e3e3e3 !important' }`">
    <v-layout child-flex @click="() => { if (!showAdd) { $emit('profile') }}" :style="showAdd ? '' : 'cursor: pointer'">
      <v-flex style="width: 90px; max-width: 90px" text-xs-center>
        <v-layout column fill-height justify-center align-center>
          <v-avatar size="64">
            <v-img class="grey lighten-1" :src="profile.photoURL || ''" contain></v-img>
          </v-avatar>
        </v-layout>
      </v-flex>
      <v-flex py-2 pl-1>
        <v-layout column fill-height justify-center align-start>
          <div :class="`font-weight-bold subheading ${ ? 'white--text' : 'grey--text text--darken-3' }`">{{ profile.name|concatName }}</div>
          <div>
            <v-icon style="font-size: 12px; vertical-align: baseline; margin-left: -1px" class="mr-1" :color="? 'amber accent-3' : 'grey darken-1'">fas fa-star</v-icon> <span :class="`${ ? 'white--text' : 'grey--text text--darken-3' } caption`">{{ profile.rating }}
              {{ $language.favorites['out of 5'] }}</span>
          </div>
          <div>
            <v-icon style="font-size: 12px; vertical-align: baseline;" class="mr-1" :color="? 'blue lighten-1' : 'grey darken-1'">fas fa-briefcase</v-icon> <span :class="`${ ? 'white--text' : 'grey--text text--darken-3' } caption`">{{ profile.completedJobs }}
              {{ $language.favorites['jobs completed'] }}</span>
          </div>
        </v-layout>
      </v-flex>
      <v-flex style="width: 60px; max-width: 60px; cursor: pointer" text-xs-center v-if="showAdd">
        <v-layout column fill-height justify-center align-center>
          <v-icon v-if="!status.loading && !isInvited" :style="`font-size: ${ $vuetify.breakpoint.xs ? '18px' : $vuetify.breakpoint.sm ? '28px' : '32px'};`" class="mr-1" color="info" @click="invite">
            fas fa-user-plus
          </v-icon>
          <v-progress-circular v-if="status.loading" small indeterminate color="primary"></v-progress-circular>
          <v-icon v-if="!status.loading && isInvited" :style="`font-size: ${ $vuetify.breakpoint.xs ? '18px' : $vuetify.breakpoint.sm ? '28px' : '32px'};`" class="mr-1" color="success">
            fas fa-check
          </v-icon>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-flex>
</v-layout> -->
</template>

<script>
import {
  mapState
} from 'vuex'
const fb = require('@/services/firebaseConfig.js')

export default {
  props: ['profileId', 'job', 'showAdd', 'dark', 'inviteMe'],
  data () {
    return {
      status: {
        loading: false,
        error: false,
        message: ''
      },
      profile: {},
      sub: ''
    }
  },
  mounted () {
    fb.database.ref(`/user/${this.profileId}/profile/public`).once('value').then(function (snapshot) {
      var profile = snapshot.val()
      this.profile = profile
    }.bind(this))
  },
  computed: {
    ...mapState(['userProfile', 'currentUser']),
    isInvited () {
      if ((this.job || {})._key) {
        var isIn = ((this.job || {}).applicants || {})[this.profileId] ? 1 : 0
        return isIn
      }
      return null
    }
  },
  methods: {
    async invite () {
      this.status.loading = true
      this.status.error = false
      this.status.message = ''
      var updates = {}
      updates[`/jobs/${this.job._key}/applicants/${this.profileId}/status`] = 'Invited'
      updates[`/jobs/${this.job._key}/applicants/${this.profileId}/name`] = this.profile.name
      updates[`/jobs/${this.job._key}/applicants/${this.profileId}/avatar`] = this.profile.photoURL
      updates[`/jobs/${this.job._key}/applicants/${this.profileId}/profileId`] = this.profileId
      updates[`/user/${this.profileId}/profile/jobInvites/${this.job._key}`] = {
        status: 'Invited',
        _key: this.job._key,
        invitedDate: new Date()
      }
      await fb.database.ref().update(updates)

      this.status.loading = false
      this.status.error = false
      this.status.message = ''
    }
  },
  watch: {
    inviteMe () {
      if (!this.isInvited) {
        this.invite()
      }
    }
    // job() {
    //   this.isInvited = ((this.job || {}).applicants || {})[this.profileId] ? 1 : 0
    //   console.log(this.isInvited);
    // }
  },
  filters: {
    concatName (val) {
      if (!val) {
        return '-'
      }
      return val.length > 20 ? val.substr(0, 15) + '...' : val
    }
  }

}
</script>
